// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //host: 'http://127.0.0.1:8080',
  host: 'https://admin.dev.myitalian.goreply.io/api',
  firebaseConfig: {
    apiKey: "AIzaSyCyCwR76X33hH65FViZbxcfVxhukiVIQGc",
    authDomain: "goreply-costa-myitalian-dev.firebaseapp.com",
    projectId: "goreply-costa-myitalian-dev",
    storageBucket: "goreply-costa-myitalian-dev.firebasestorage.app",
    messagingSenderId: "898285063004",
    appId: "1:898285063004:web:79b20cef2ee25fa4564f99"
  },
  firebaseProvider : 'oidc.auth2-myitalian-dev'
};
